import { render, staticRenderFns } from "./DebugView.vue?vue&type=template&id=085fc590&scoped=true"
import script from "./DebugView.vue?vue&type=script&lang=js"
export * from "./DebugView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085fc590",
  null
  
)

export default component.exports